import { z } from "zod";

import { bookIdSchema } from "./bibleManifestSchema";

export const bibleSearchableSchema = z.partialRecord(
  bookIdSchema,
  z.object({ title: z.string() }).catchall(z.record(z.string(), z.string())),
);

export type BibleSearchableJson = z.infer<typeof bibleSearchableSchema>;
